// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"a29ecf19","483":"c5d071a3","636":"89bb2516","914":"0d3eed05"}[chunkId] + ".chunk.js";
};